const aiAds = require('../../../ads/frontend/ai_ads');

class CardsView {
  constructor({ el }) {
    this.el = el;
  }

  retrieveElementSelector(el = this.el) {
    if (el) {
      this.elementSelector = document.querySelector(el);
      return this.elementSelector;
    }
    return null;
  }

  render(cardsHtml, aiAdsHash) {
    if (this.retrieveElementSelector()) {
      this.elementSelector.innerHTML = cardsHtml;
    }
    aiAds.refresh(aiAdsHash);
  }

  append(cardsHtml) {
    if (this.retrieveElementSelector()) {
      this.elementSelector.insertAdjacentHTML('beforeend', cardsHtml);
    }
  }

  insertAfter(cardsHtml, card) {
    if (this.retrieveElementSelector(card)) {
      this.elementSelector.insertAdjacentHTML('afterend', cardsHtml);
    }
  }
}

module.exports = CardsView;
